import * as React from 'react';
export const paperclipSvg = React.forwardRef(function paperclipSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10 1.5c-.682 0-1.25.568-1.25 1.161v8.416a.75.75 0 0 1-1.5 0V2.661C7.25 1.153 8.579 0 10 0s2.75 1.153 2.75 2.661v8.846C12.75 14.057 10.41 16 8 16c-2.52 0-4.5-2.01-4.5-4.493V4.513a.75.75 0 1 1 1.5 0v6.994A2.973 2.973 0 0 0 8 14.5c1.715 0 3.25-1.399 3.25-2.993V2.661c0-.593-.569-1.161-1.25-1.161Z',
    }),
  );
});
paperclipSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var paperclip = {
  category: 'icon',
  colorable: true,
  name: 'paperclip',
  svg: paperclipSvg,
};
